import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: () => import('../views/Gallery')
  },
  {
    path: '/book',
    name: 'Booking',
    component: () => import('../views/Booking')
  },
  {
    path: '/stancija',
    name: 'Stancija',
    component: () => import('../views/Stancija')
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import('../views/Services')
  },
  {
    path: '/experience',
    name: 'Experience',
    component: () => import('../views/Experience')
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('../views/PrivacyPolicy')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
})

export default router
